import { createPopper } from '@popperjs/core';

/** Selector for any instance of this _Friendation_ component */
const selector = '[is="block-image-interactive"]';

/**
 * Friendation component
 */
export const blockImageInteractive = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((component) => {
    const handlePopups = () => {
      const triggers: HTMLButtonElement[] = Array.from(
        component.querySelectorAll('.poi')
      );

      const resetAll = () => {
        triggers.forEach((trigger) => {
          hideToolTip(trigger);
        });
        document.addEventListener('keydown', onKeydown);
      };

      const onKeydown = (e: KeyboardEvent) => {
        if (e.code === 'Escape') {
          resetAll();
        }
      };

      const showTooltip = (trigger: HTMLButtonElement) => {
        resetAll();
        findTooltip(trigger).inert = false;
        trigger.setAttribute('aria-expanded', 'true');
        document.addEventListener('keydown', onKeydown);
      };

      const hideToolTip = (trigger: HTMLButtonElement, focus?: boolean) => {
        findTooltip(trigger).inert = true;
        trigger.setAttribute('aria-expanded', 'false');

        if (focus) {
          setTimeout(() => {
            trigger.focus();
          }, 100);
        }
      };

      const findTooltip = (trigger: HTMLButtonElement) => {
        const tooltip: HTMLElement = component.querySelector(
          `[id="${trigger.getAttribute('aria-controls')}"]`
        );

        return tooltip;
      };

      triggers.forEach((trigger) => {
        const tooltip = findTooltip(trigger);

        createPopper(trigger, tooltip, {
          placement: 'auto',
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 16]
              }
            }
          ]
        });

        const onClick = (e: MouseEvent) => {
          e.preventDefault();

          if (tooltip.inert) {
            showTooltip(trigger);
          } else {
            hideToolTip(trigger, true);
          }
        };

        trigger.addEventListener('click', onClick);
      });
    };

    handlePopups();
  });
};
